document.addEventListener('DOMContentLoaded', function() {
  const descEl = document.querySelector('.cc-tabs__tab__panel.Description.rte');
  if (!descEl) return;

  const toggleBtn = document.createElement('button');
  toggleBtn.className = 'view-more-btn';
  toggleBtn.innerHTML = `
    <span class="label">View more</span>
    <svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
      <path d="M5.5 7.5L10 12l4.5-4.5" stroke="currentColor" stroke-width="1.8" fill="none" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
  `;

  descEl.insertAdjacentElement('afterend', toggleBtn);

  toggleBtn.addEventListener('click', () => {
    const expanded = descEl.classList.toggle('expanded');
    toggleBtn.classList.toggle('active', expanded);
    toggleBtn.querySelector('.label').textContent = expanded ? 'View less' : 'View more';
  });
});
